<script>
import Badge from "@/components/atoms/badge";
import PopinAnchor from "@/components/molecules/popin-anchor";

export default {
  components: {
    Badge,
    PopinAnchor
  },
  props: {
    quantiteEresa: {
      type: Number,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: null
    },
    infobulle: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ["add-to-eresa"]
};
</script>

<template>
  <div class="c-eresa-button">
    <PopinAnchor
      popin-size="fit"
      position="top"
      open-on-hover
      :size="size"
      :icon-size="size"
      :infobulle="infobulle"
      icon-name="click-collect"
      radius="full"
      outline
      variant="secondary"
      icon-color="secondary"
      aria-label="Réserver cet article en Click & Collect"
      @click="$emit('add-to-eresa')"
    >
      <p
        v-if="infobulle"
        class="u-font-14 u-color-text"
      >
        Réserver cet article<br />en Click & Collect
      </p>
    </PopinAnchor>
    <Badge
      v-if="quantiteEresa > 0"
      circle
      variant="secondary"
      size="sm"
      class="c-eresa-button__badge"
    >
      {{ quantiteEresa }}
    </Badge>
  </div>
</template>

<style scoped lang="scss">
.c-eresa-button {
  position: relative;
}

.c-eresa-button__badge {
  position: absolute;
  top: -0.4rem;
  right: -0.4rem;
  font-size: 1.2rem;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}
</style>
